"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = doLimit;
function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async-eventemitter/~/async/internal/doLimit.js
// module id = 345
// module chunks = 0